export default __webpack_public_path__ + "static/media/GAR_logo.1a2aa849.png";